import React from 'react'
import Style from './FJResources.module.less';
import classNames from 'classnames'

function FJResources(props) {
  return (
    <div className={classNames(Style.resource, {[Style.expand]: props.isExpand})}>
      {props.children}
    </div>
  )
}

export default FJResources;
